import { z } from 'zod'
import { UuidSchema } from '../../../utils/zodUuid'
import type {
  AdvanceTarget,
  AdvanceWorkflowRecordInput,
} from './advanceActions'
import { ConfiguredFieldValuesInputSchema } from './configuredFieldSchemas'

/** Accepts only Closed or a custom-status destination, normalizing UUID identity. */
const AdvanceTargetSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('closed') }).strict(),
  z
    .object({
      type: z.literal('status'),
      statusId: UuidSchema,
    })
    .strict(),
]) satisfies z.ZodType<AdvanceTarget>

/** Checks request shape before the API resolves the current advancement rules. */
export const AdvanceWorkflowRecordInputSchema = z
  .object({
    recordId: UuidSchema,
    target: AdvanceTargetSchema,
    values: ConfiguredFieldValuesInputSchema,
  })
  .strict() satisfies z.ZodType<AdvanceWorkflowRecordInput>
